import { OrderDetail } from "./orderDetails";

export class UpdateQuantity {
  public statusCode: string = "";
  public uniqueTrackingNumber: string = "";
  public distributionCenter: number = 0;
  public customerNumber: number = 0;
  public userId: string = "";
  public apiKey: string = "";
  public axwayPassword: string = "";
  public orderCreateSTP: string = "";
  public orderId: string = "";
  public operationName: string = "";
  public operationNameOld: string = "";
  public orderLines: Array<OrderDetail> = [];
}
